<template>
  <nav class="navbar navbar-expand-lg navbar-light" v-if="auth">
    <div class="container-fluid">
      <a class="navbar-brand" href="#"></a>
      <button 
        class="navbar-toggler navbar-burger"
        type="button"
        @click="toggleSidebar"
        :aria-expanded="$sidebar.showSidebar"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-bar"></span>
        <span class="navbar-toggler-bar"></span>
        <span class="navbar-toggler-bar"></span>
      </button>
      <div class="collapse navbar-collapse" >
        <ul class="navbar-nav ml-auto">
          <!-- <li class="nav-item">
            <a href="#" class="nav-link">
              <i class="ti-panel"></i>
              <p>Stats</p>
            </a>
          </li> -->
          <!-- <drop-down
            class="nav-item"
            title="5 Notifications"
            title-classes="nav-link"
            icon="ti-bell"
          >
            <a class="dropdown-item" href="#">Notification 1</a>
            <a class="dropdown-item" href="#">Notification 2</a>
            <a class="dropdown-item" href="#">Notification 3</a>
            <a class="dropdown-item" href="#">Notification 4</a>
            <a class="dropdown-item" href="#">Another notification</a>
          </drop-down>  -->
          <li class="nav-item" v-if="auth">
            <a href="#" class="nav-link bg-dark" @click="cerrarSesion">
              <b> <i class="ti-shift-right text-light"></i> </b>
              <p > <b class="text-white"> Cerrar Sesion </b></p>
            </a>
          </li> 
        </ul>
      </div>
    </div>
  </nav>
</template>
<script>
export default {
  computed: {
    routeName() {
      const { name } = this.$route;
      return this.capitalizeFirstLetter(name);
    },
  },
  data() {
    return {
      activeNotifications: false,
      auth:{},

    };
  },
  methods: {
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications;
    },
    closeDropDown() {
      this.activeNotifications = false;
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },

    cerrarSesion() {
      console.log("top");
      localStorage.clear();
      this.auth={};
      // console.log("this.auth",this.auth);
      this.$router.push('/Login');
      location.reload();

        // if (!this.auth) {
        //     // this.$router.push('/Login');
        //   console.log("this.auth if",this.auth);

        // }
        // this.$router.push("/login");
        if (this.$msal.isAuthenticated()) {
            this.$msal.signOut();
        }
    },
  },

   mounted() {

    // console.log("auth luego de cerrar y antes",this.auth);

    this.auth = JSON.parse(localStorage.getItem('usuario'));
    // console.log("auth cerrar sesion",this.auth);
    // this.$watch("$route", this.findActiveLink, {
    //   immediate: true,
    // });
  },
};
</script>
<style></style>
